<script setup>
import i18n from "@/i18n"
import { ref, reactive, onBeforeMount } from "vue";
import { showMessage } from "@/utils/hooks/message"
import {
    login as loginApi,
    //  getOrganizationList
} from "@/service/index"
import { getLangValue } from "@/utils/common"; //获取后端语言
import { useRouter } from "vue-router";
import { getLangData } from "@/service/apiList/lang.js"
import store from "@/state/store";
const router = useRouter();
const chineseClick = () => {
    const language = "ch";
    sessionStorage.setItem("language", language);
    i18n.global.locale = language;
}
const englishClick = () => {
    const language = "en";
    sessionStorage.setItem("language", language);
    i18n.global.locale = language;
}
const showIndex = ref(0)  // 1 最原始的页面   2 验证人机页面 3 提示页面  4 注册页面
const formData = reactive({
    title: getLangValue('login.login'),
    company: '',
    email: sessionStorage.getItem("username") || "",
    password: sessionStorage.getItem("password") || "",
    confirmPassword: '',
    confimInfo: false,
    type: 0, // 0-注册  1-重置密码
    remember: sessionStorage.getItem("password") ? true : false,
})
const isCheckForm = ref(false)
const langLoading = ref(false) // 语言是否加载完毕
// const companyList = ref([
//     {
//         id: '669a34d143d17c59b9b5a10d',
//         name: 'admin'
//     }
// ])
const goregister = () => {
    router.push({ path: '/register' })
}

const forgetPassword = () => {
    router.push({ path: '/forgetPassword' })
}
const switchPassword = (typeIndex = 0) => {
    if (typeIndex == 0) {
        let type = document.getElementById('password-input').getAttribute('type');
        document.getElementById('password-input').setAttribute('type', type == 'text' ? 'password' : 'text')
    } else {
        // console.log(type);
        let type = document.getElementById('password-input' + typeIndex).getAttribute('type');
        document.getElementById('password-input' + typeIndex).setAttribute('type', type == 'text' ? 'password' : 'text')
    }
}

/**
 * 登录部分
 */
const login = async () => {
    // 判断验证是否通过
    // console.log(formData);
    isCheckForm.value = true;
    if (!formData.email) {
        showMessage('danger', getLangValue('base.requiredinformation'))
        return false
    }
    if (!formData.password) {
        showMessage('danger', getLangValue('base.requiredinformation'))
        return false
    }
    let params = {
        username: formData.email,
        password: formData.password,
        company_name: formData.organization
    }
    // 登录
    const resp = await loginApi(params)
    if (resp) {
        // if (resp.code == 0) {
        // showMessage('success',getLangValue('login.message14'))
        const data = JSON.stringify(resp);
        store.commit("login/set_menu_list", data);
        sessionStorage.setItem("set_menu_list", data);
        if (formData.remember) {
            sessionStorage.setItem("username", params.username);
            sessionStorage.setItem("password", params.password);
        } else {
            sessionStorage.removeItem("username");
            sessionStorage.removeItem("password");
        }
        sessionStorage.setItem("is_login", true);
        // await _getLangData();
        router.push("/homePage");
        // 跳转到首页
        // router.push('/')
        // } else {
        //     showMessage('danger', resp.message)
        // }
    }
}



const switchUsername = () => {
    //本地切换用户 减少输入时间
    let href = window.location.href
    if (href.indexOf("localhost") == -1 && href.indexOf("192.168") == -1) return
    let list = [
        { username: 'admin', password: '123456' },
        { username: '2819114150@qq.com', password: '123456', organization: '小猪佩奇' },
        { username: 'tao.feng1@goldendata.cloud', password: 'Ft12345#', organization: '猪坚强1号' },
        { username: 'aaa@test.com', password: 'Qq123456*', organization: 'AAA制造公司' },
        { username: 'ccc@test.com', password: 'Qq123456*', organization: 'CCC制造公司' },
        { username: 'fff@test.com', password: 'Qq123456*', organization: 'FFF制造公司' },
    ]
    if (!formData.email) {
        formData.email = list[0].username
        formData.password = list[0].password
    } else {
        const index = list.findIndex(item => item.username == formData.email)
        if (index == list.length - 1) {
            formData.email = list[0].username
            formData.password = list[0].password
            formData.organization = list[0].organization ? list[0].organization : ''
        } else {
            formData.email = list[index + 1].username
            formData.password = list[index + 1].password
            formData.organization = list[index + 1].organization ? list[index + 1].organization : ''
        }
    }
}

// const getOrganization = async ()=> {
//     const resp = await getOrganizationList()
//     if (resp.code == 0) {
//         companyList.value = resp.payload
//     }else{
//         showMessage('danger', resp.message)
//     }
// }

/**
* 登录部分
*/

const _getLangData = async () => {
    // 获取语言JSON数据
    langLoading.value = true;
    try {
        const reps = await getLangData();
        if (reps.code === 0) {
            sessionStorage.setItem("custom-lang", JSON.stringify(reps.payload));
        }
        langLoading.value = false;
    }catch(e){
        langLoading.value = false;
        console.log(e);
    }
    
}


onBeforeMount(async () => {
    // getOrganization()
    await _getLangData();
})
</script>

<template>
    <div class="auth-page-wrapper pt-5" v-loading="langLoading">
        <div class="auth-one-bg-position auth-two-bg" id="auth-particles" style="height: 380px;">
            <div class="bg-overlay"></div>
            <div class="shape">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 1440 120">
                    <path fill="#f3f3f9"
                        d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z">
                    </path>
                </svg>
            </div>
        </div>

        <div class="auth-page-content">
            <b-container>
                <div class="col-12 logo-box " style="margin-top: 70px;">
                    <div class="text-center text-white-50">
                        <!-- <img :src="logoImg" alt="" style="height: 128px" /> -->
                        <!-- <p style="font-size: 24px;" class="login-logo mb-0" v-if="Env == 'en'">
                            Start your digital transformation journey
                        </p> -->
                        <p style="font-size: 24px;" class="login-logo mb-0">{{ getLangValue('login.helloWord') }}</p>
                    </div>
                </div>

                <b-row class="justify-content-center">
                    <b-col md="8" lg="6" xl="5">
                        <b-card no-body class="mt-4">
                            <b-card-body class="p-4">
                                <div class="text-r mt-2 d-flex justify-content-between "
                                    style="color: #405189; text-align: right;">
                                    <div>
                                        <span>{{ formData.title }}</span>
                                    </div>
                                    <div>
                                        <span @click="chineseClick">{{ getLangValue('login.chinese') }}</span> | <span
                                            @click="englishClick">{{ getLangValue('login.english') }}</span>
                                    </div>
                                </div>
                                <div class="text-center py-4"
                                    style="font-size: 20px; font-weight: bold; color: #212529;">
                                    {{ getLangValue('login.title') }}
                                </div>
                                <div class="p-2 mt-4" v-if="showIndex == 0">
                                    <form>
                                        <div class="mb-3">
                                            <label for="organization" class="form-label">{{
                                                getLangValue('login.companyOgn')
                                                }}</label>
                                            <input v-model="formData.organization" type="text" class="form-control"
                                                id="organization" :placeholder="getLangValue('login.companyOgn')">
                                            <!-- <Multiselect class="form-control"
                                               :placeholder="getLangValue('login.companyOgn')"
                                                v-model="formData.organization" :options="companyList" value-prop="username"
                                                label="company_name" required /> -->
                                        </div>
                                        <div class="mb-3">
                                            <label for="username" class="form-label  " @click="switchUsername">{{
                                                getLangValue('login.username') }}
                                                <!-- <span class="text-danger">*</span> -->
                                            </label>
                                            <input type="text" class="form-control"
                                                :class="[(isCheckForm && !formData.email) && 'is-invalid']"
                                                id="username" v-model="formData.email"
                                                :placeholder="getLangValue('login.enter') + getLangValue('login.username')">
                                        </div>
                                        <div class="">
                                            <label class="form-label " for="password-input">{{
                                                getLangValue('login.password')
                                                }}
                                                <!-- <span class="text-danger">*</span> -->
                                            </label>
                                            <div class="position-relative auth-pass-inputgroup mb-3">
                                                <input type="password"
                                                    :class="[(isCheckForm && !formData.password) && 'is-invalid']"
                                                    class="form-control pe-5" v-model="formData.password"
                                                    :placeholder="getLangValue('login.enter') + getLangValue('login.password')"
                                                    id="password-input2">
                                                <b-button variant="link" @click="switchPassword(2)"
                                                    class="position-absolute end-0 top-0 text-decoration-none text-muted"
                                                    type="button" id="password-addon2"><i
                                                        class="ri-eye-fill align-middle"></i></b-button>
                                            </div>
                                        </div>

                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value=""
                                                v-model="formData.remember" id="auth-remember-check">
                                            <label class="form-check-label" for="auth-remember-check">{{
                                                getLangValue('login.remember') }}</label>
                                            <div class="float-end">
                                                <a class="text-muted cursor-pointer" @click="forgetPassword">{{
                                                    getLangValue('login.forgetpassword') }}?
                                                </a>
                                            </div>
                                        </div>

                                        <div class="mt-4">
                                            <b-button variant="success" class="w-100" @click="login">{{
                                                getLangValue('login.login')
                                                }}</b-button>
                                        </div>
                                        <div class="mt-4 text-center">
                                            <p class="mb-0">{{ getLangValue('login.noAccount') }}
                                                <a class="fw-bold text-decoration-underline cursor-pointer"
                                                    @click="goregister">
                                                    {{ getLangValue('login.register') }}
                                                </a>
                                            </p>
                                        </div>
                                    </form>

                                </div>

                            </b-card-body>
                        </b-card>



                    </b-col>
                </b-row>
            </b-container>
        </div>

        <footer class="footer">
            <b-container>
                <b-row>
                    <b-col lg="12">
                        <div class="text-center">
                            <p class="mb-0 text-muted">© 2024 Powered by<i class="mdi mdi-heart text-danger"></i>Digital
                                Clothing</p>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </footer>
    </div>
</template>
<style scoped lang="scss">
/* .login {
    height: 100vh;
    background-image: url('../../assets/images/login/bg.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
} */
.auth-two-bg {
    background-image: url('../../assets/images/auth-one-bg.jpg');
    background-position: center;
    background-size: cover;

    .bg-overlay {
        background: -webkit-gradient(linear, left top, right top, from(#364574), to(#405189));
        background: linear-gradient(to right, #364574, #405189);
        opacity: .9;
    }
}

.shape {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1;
    pointer-events: none;
}

.is-invalid {
    background-image: unset;
}
</style>
